var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalanceBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 436,
    viewBox: "0 0 568 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 568,
    height: 436,
    rx: 8,
    fill: "#5356FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M-2.34293e-05 0.000290263L-2.36998e-06 373.766C34.8829 399.565 69.9041 417.424 105.302 415.717C249.583 408.752 290.189 107.406 438.452 53.7809C479.95 38.7715 522.248 57.1748 565 87.2609L565 0.000213623L-2.34293e-05 0.000290263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M3.05176e-05 436L393.417 436C396.14 415.924 396.846 395.977 394.881 376.207C377.132 197.532 170.752 155.022 89.7893 4.1536e-05L5.95177e-06 5.37155e-05L3.05176e-05 436Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceBg);
export default __webpack_public_path__ + "static/media/balance-bg.2fb076e7dc397daecbe47caeaa5f097d.svg";
export { ForwardRef as ReactComponent };